import { render, staticRenderFns } from "./SubCategory.vue?vue&type=template&id=17633a4a&scoped=true"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"
import style0 from "./SubCategory.vue?vue&type=style&index=0&id=17633a4a&prod&scoped=true&lang=css"
import style1 from "./SubCategory.vue?vue&type=style&index=1&id=17633a4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17633a4a",
  null
  
)

export default component.exports